import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { Shield, Download, Clock, Lock } from 'lucide-react';
export function OfferSection() {
  return <section id="offer-section" className="py-20 px-4 bg-secondary/5" data-id="element-133">
      <div className="max-w-4xl mx-auto" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-135">
          <Card className="border-2 border-primary/20 shadow-xl relative overflow-hidden" data-id="element-136">
            {/* Top accent bar */}
            <div className="absolute top-0 left-0 w-full h-2 bg-primary" data-id="element-137"></div>

            <div className="p-4 md:p-8 text-center" data-id="element-138">
              <h2 className="text-3xl md:text-4xl font-bold mb-6 font-serif text-foreground" data-id="element-139">
                Get Started This Weekend
              </h2>

              <p className="text-xl text-foreground/80 mb-8 max-w-2xl mx-auto" data-id="element-140">
                Get the full{' '}
                <strong className="text-foreground" data-id="element-141">
                  Goodbye Diapers in 3 Days
                </strong>{' '}
                system today. Save hundreds on diapers and remove daycare stress
                for less than a big box of Pampers.
              </p>

              <div className="bg-accent/50 rounded-2xl p-8 mb-8 inline-block min-w-[300px]" data-id="element-142">
                <div className="text-sm font-bold text-foreground/60 uppercase tracking-wider mb-2" data-id="element-143">
                  One-time price
                </div>
                <div className="flex items-center justify-center gap-3 mb-1" data-id="element-144">
                  <span className="text-2xl text-foreground/40 line-through font-bold" data-id="element-145">
                    $27
                  </span>
                </div>
                <div className="flex items-start justify-center" data-id="element-146">
                  <span className="text-3xl font-bold text-primary mt-2" data-id="element-147">
                    $
                  </span>
                  <span className="text-7xl font-bold text-primary tracking-tighter" data-id="element-148">
                    6.36
                  </span>
                </div>
                <div className="mt-2 inline-block bg-primary/10 text-primary font-semibold text-sm px-3 py-1 rounded-full" data-id="element-149">
                  76% OFF — Limited Time
                </div>
              </div>

              <div className="max-w-md mx-auto mb-8" data-id="element-150">
                <Button size="xl" fullWidth animate onClick={() => {
                if (window.fbq) {
                  window.fbq('track', 'AddToCart', {
                    content_name: 'Goodbye Diapers in 3 Days',
                    content_type: 'product',
                    value: 6.36,
                    currency: 'USD'
                  });
                }
                window.open('https://coresolutionsg.com/cart/47492585324731:1', '_blank');
              }} className="text-wrap py-4 h-auto min-h-[4rem] text-lg md:text-xl shadow-glow" data-id="element-151">
                  YES — GET MY CHILD DIAPER-FREE NOW
                </Button>
                <p className="text-sm text-foreground/60 mt-3" data-id="element-152">
                  Download the PDF instantly and start this weekend
                </p>
              </div>

              {/* Trust Badges */}
              <div className="flex flex-wrap justify-center gap-6 text-sm text-foreground/70 font-medium pt-8 border-t border-border" data-id="element-153">
                <div className="flex items-center gap-2" data-id="element-154">
                  <Download className="w-5 h-5 text-secondary" data-id="element-155" />
                  <span data-id="element-156">Instant Access</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-157">
                  <Lock className="w-5 h-5 text-secondary" data-id="element-158" />
                  <span data-id="element-159">Secure Checkout</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-160">
                  <Clock className="w-5 h-5 text-secondary" data-id="element-161" />
                  <span data-id="element-162">Works in 72 Hours</span>
                </div>
              </div>
            </div>
          </Card>
        </motion.div>
      </div>
    </section>;
}